import ParticlesComponent from '@c/particles/ParticlesComponent';
import { getProductSlug } from '@util/urlHelpers';
import { ProductDocument } from 'models/product';
import React from 'react';
import ShareModal from './ShareModal';
import { useRouter, useSearchParams } from 'next/navigation';

const ShareProductModal = ({ product }: { product: ProductDocument }) => {
  const params = useSearchParams();
  const router = useRouter();
  return (
    <>
      <ShareModal
        title={product.title}
        thumb={product.thumbnail}
        id={product.id}
        isOpen={!!params?.get('share')}
        dismiss={() => router.replace(getProductSlug(product))}
        removeQuery
      />

      {!!params?.get('share') && <ParticlesComponent />}
    </>
  );
};

export default ShareProductModal;
